import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Button } from 'primereact/button';
import AuthLayout from './AuthLayout';
import { emailApi } from '../api/services';
import { useAlerts } from '../custom/Alerts';

/* /confirm/:id/:code (link iz mejla) i /verify (posle prijave/registracije sa nepotvrđenim mejlom). */
export default function VerifyEmail() {
    const { id, code } = useParams();
    const history = useHistory();
    const location = useLocation();
    const alerts = useAlerts();
    const user = location.state && location.state.user;
    const [text, setText] = useState(id ? 'Verifikacija u toku...' : '');
    const [sent, setSent] = useState(false);

    useEffect(() => {
        if (!id) return undefined;
        let timer;
        emailApi.confirm(id, code)
            .then(() => {
                alerts.success('Email uspešno verifikovan');
                setText('Email uspešno verifikovan.');
            })
            .catch(() => setText('Verifikacija neuspešna!'))
            .finally(() => { timer = setTimeout(() => history.replace('/login'), 2000); });
        return () => clearTimeout(timer);
    }, [id, code]);

    useEffect(() => {
        if (id || !user || !user.emailConfirmed) return undefined;
        setText('Email je već verifikovan!');
        const t = setTimeout(() => history.replace('/login'), 2000);
        return () => clearTimeout(t);
    }, [id, user]);

    const resend = async () => {
        try {
            await emailApi.resend(user.email);
            setSent(true);
        } catch { /* toast prikazuje interceptor */ }
    };

    let body = text;
    if (!id) {
        if (!user || !user.email) body = 'Morate se prijaviti pre pokušaja verifikacije Vaše email adrese.';
        else if (!user.emailConfirmed) {
            body = sent
                ? 'Aktivacioni kod je poslat na Vašu e-mail adresu.'
                : 'Morate potvrditi Vašu email adresu. Proverite aktivacioni kod koji je poslat na Vašu email adresu. Ukoliko niste dobili aktivacioni kod, proverite SPAM ili Junk folder ili pošaljite novi klikom na dugme "Pošalji ponovo".';
        }
    }

    return (
        <AuthLayout>
            <div className="auth-text">{body}</div>
            {!id && user && !user.emailConfirmed && !sent && <Button label="Pošalji ponovo" onClick={resend} />}
            {!id && <Button label="Nazad na prijavu" text onClick={() => history.push('/login')} />}
        </AuthLayout>
    );
}
